// extracted by mini-css-extract-plugin
export default {"button":"CreateOrEditPurchase_button__PA5Y4","items":"CreateOrEditPurchase_items__heNei","notice":"CreateOrEditPurchase_notice__Tk6zD","form":"CreateOrEditPurchase_form__erL89"};